import { useMutation, useQueryClient } from 'react-query';
import {
  deleteBettieProfilePicture,
  type DeleteBettieProfilePictureResponse
} from '../../services/bettieProfileService';

export function useDeleteBettieProfilePicture() {
  const queryClient = useQueryClient();
  return useMutation<DeleteBettieProfilePictureResponse, Error, { chatRoomId: string }>(
    ({ chatRoomId }) => deleteBettieProfilePicture(chatRoomId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['bettieChatRoomPictures']);
      }
    }
  );
}
